import React from "react";
import { Badge } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { HeaderToggleButton } from "./CustomMUI";
import { useUnreadNotificationCount } from "../hooks/useCustomQuery";

/**
 * Reusable hamburger button for opening the nav drawer from any header.
 * Shows an unread-notification dot (via MUI Badge) when there are unseen
 * what's-new updates, giving mobile users a visible signal before they open
 * the drawer where the dot normally lives.
 *
 * Hidden at the `md` breakpoint and above (where the drawer is always visible).
 */
const HeaderMenuButton = ({ onClick, sx }) => {
  const { data: unread } = useUnreadNotificationCount("whats_new");

  return (
    <HeaderToggleButton
      aria-label="open drawer"
      edge="start"
      onClick={onClick}
      size="small"
      value="menu"
      sx={{
        display: { md: "none" },
        "&.MuiButtonBase-root.MuiToggleButton-root": {
          border: "none",
          borderRadius: 1,
        },
        ...sx,
      }}
    >
      <Badge
        variant="dot"
        color="primary"
        invisible={!unread?.count}
        overlap="rectangular"
      >
        <MenuIcon />
      </Badge>
    </HeaderToggleButton>
  );
};

export default HeaderMenuButton;
